export function getFromCount(pageNumber = 1, pageSize = 10) {
  return (pageNumber - 1) * pageSize;
}
